import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
  Divider,
} from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";

export default function ProductInfoCard({
  open,
  onClose,
  productInfo = [],
  mainTitle,
  modelTitle,
}) {
  const features = [
    "Smartplay Studio",
    "Next Gen K-Series Engine",
    "Engine Push-Start Button",
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 350,
          m: 0,
          position: "fixed",
          bottom: 90,
          right: 70,
          top: "auto",
          left: "auto",
          transform: "none",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "transparent",
        },
      }}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-end",
          justifyContent: "flex-end",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        {/* Header */}
        <Box sx={{ p: 3, pb: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1,
            }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold", fontSize: "1.5rem" }}
            >
              {`${mainTitle} + ${modelTitle}`}
            </Typography>
            <KeyboardArrowDown sx={{ color: "text.secondary" }} />
          </Box>
          <Typography
            variant="body1"
            sx={{ color: "text.primary", fontSize: "1rem" }}
          >
            Petrol ₹ 7 37 000
          </Typography>
        </Box>

        <Divider />

        {/* Specifications from productInfo */}
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 3,
              mb: 3,
            }}
          >
            {productInfo.map((spec, index) => (
              <Box key={index}>
                <Typography
                  variant="caption"
                  sx={{
                    color: "text.secondary",
                    fontSize: "0.75rem",
                    fontWeight: "500",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    display: "block",
                    mb: 0.5,
                  }}
                >
                  {spec.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.primary",
                    fontSize: "0.875rem",
                    fontWeight: "500",
                  }}
                >
                  {spec.value}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Features */}
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                fontSize: "0.75rem",
                fontWeight: "500",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                display: "block",
                mb: 2,
              }}
            >
              FEATURES
            </Typography>
            <Box
              sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}
            >
              {features.map((feature, index) => (
                <Box
                  key={index}
                  sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
                >
                  <Box
                    sx={{
                      width: 4,
                      height: 4,
                      bgcolor: "text.primary",
                      borderRadius: "50%",
                      mt: 0.75,
                      flexShrink: 0,
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.875rem",
                      lineHeight: 1.4,
                      color: "text.primary",
                    }}
                  >
                    {feature}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* <Button
            variant="contained"
            fullWidth
            sx={{
              bgcolor: "#3f51b5",
              color: "white",
              py: 1.5,
              fontSize: "1rem",
              fontWeight: "600",
              textTransform: "none",
              borderRadius: 1,
              "&:hover": {
                bgcolor: "#303f9f",
              },
            }}
            onClick={onClose}
          >
            Change Variant
          </Button> */}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
